<!-- TODO: Enable Feature -->
 <mat-card>
  <mat-card-content>
    <div class="subtitle">
      <p>System prompts define the behavior of AI models in different contexts. They can be edited to customize how the models respond to user queries.</p>
    </div>

  
<div *ngFor="let prompt of systemPrompts">
    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>
          {{ prompt.prompt_type }} System Prompt {{ prompt.editing? '--editing': '' }}
          <button
            mat-icon-button
            class="more-button"
            [matMenuTriggerFor]="menu"
            aria-label="Toggle menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onToggleEdit(prompt.id, true)">
              Edit Prompt
            </button>
          </mat-menu>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="dashboard-card-content" *ngIf="!prompt.editing; else editing">
        <div>{{ prompt.prompt }}</div>
      </mat-card-content>
      <ng-template #editing>
        <mat-card-content class="dashboard-card-content" *ngIf="prompt.editing">
            <mat-form-field>
            <mat-label>Edit {{prompt.prompt_type}} Prompt</mat-label>
            <textarea 
              matInput [(ngModel)]="prompt.prompt" 
              [rows]="prompt.prompt.length > 400? 10: 6"></textarea>
            </mat-form-field>
        </mat-card-content>
      </ng-template>
      <div class="save-button" *ngIf="prompt.editing">
        <button
          mat-stroked-button
          (click)="
            onSaveEdit({
              id: prompt.id, 
              name: prompt.name,
              arn: prompt.arn,
              prompt_type: prompt.prompt_type,
              version: prompt.version,
              prompt: prompt.prompt
            })
          "
        >
          Save
        </button>
        <button mat-stroked-button (click)="onToggleEdit(prompt.id, false)">
          Discard
        </button>
      </div>
    </mat-card>
  </div>
  </mat-card-content>
  </mat-card>
